// extracted by mini-css-extract-plugin
module.exports = {"root":"ImagesGallery_root__12SMD","halfRoot":"ImagesGallery_halfRoot__3JIWI","halfPreview":"ImagesGallery_halfPreview__3EhHl","fullPreview":"ImagesGallery_fullPreview__WY4-6"};